import React from "react"
import dayjs from "dayjs";

export default function ForumDetail({selectedForum, close}) {
    return(
        <div className={'forum-detail create-forum'}>
            <ul>
                <li>
                    <h5>Date</h5>
                    <p>{selectedForum?.date ? dayjs(selectedForum.date).format("DD/MM/YYYY") : "No Date Available"}</p>
                </li>
                {Object.entries(selectedForum.progressUpdate).map(([key, value]) => (
                    <li key={key}>
                        <h4>{key.charAt(0).toUpperCase() + key.slice(1)}</h4>
                        <h5>Headline</h5>
                        <p style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{value?.headline}</p>
                        <h5>Emotion : What emotions am i feeling?</h5>
                        <p style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{value?.emotion}</p>
                        <h5>Impact : Why this is significant for me?</h5>
                        <p style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{value?.impact}</p>
                    </li>
                ))}
            </ul>
        </div>
    )
}